<script setup>
import { ref, provide, computed, watch, onMounted } from 'vue'
import { useLocaleStore } from '@/store/modules/locale'
import { useAppStore } from '@/store/modules/app'
import { setCssVar } from '@/utils'

const htmlFontSize = ref(16)
const appStore = useAppStore()
// 多语言相关
const localeStore = useLocaleStore()
const props = defineProps({
  size: {
    type: String,
    default: ''
  }
})
provide('configGlobal', props)

const currentLocale = computed(() => localeStore.currentLocale)
const theme = computed(() => {
  return {
    token: {
      colorPrimary: '#3F6DF3',
      colorLink: '#3F6DF3',
      colorError: '#FA0000',
      colorBorder: '#EDEDED',
      fontSize: htmlFontSize.value,
      lineHeight: 1,
      borderRadius: htmlFontSize.value / 2
    },
    components: {
      Form: {
        colorError: '#E02020'
      },
      Button: {
        colorTextDisabled: '#C8C8C8'
      }
    }
  }
})

const getPopupContainer = (el, dialogContext) => {
  return dialogContext?.getDialogWrap() || document.body
}
// 获取纯数值的html字体大小
const getHtmlFontSizeFn = () => {
  htmlFontSize.value = parseFloat(window.getComputedStyle(document.documentElement).fontSize)
}
getHtmlFontSizeFn()

window.addEventListener('resize', getHtmlFontSizeFn)
// // 初始化所有主题色
// onMounted(() => {
//   appStore.setCssVarTheme()
// })
</script>

<template>
  <a-config-provider
    :getPopupContainer="getPopupContainer"
    :locale="currentLocale.elLocale"
    :componentSize="size"
    :theme="theme"
  >
    <template #renderEmpty>
      <a-empty class="py-27">
        <template #image>
          <img class="w-23 h-23" src="@/assets/svgs/common/tableNoData.svg" alt="no data" />
        </template>
      </a-empty>
    </template>
    <a-app>
      <slot></slot>
    </a-app>
  </a-config-provider>
</template>
